export default __webpack_public_path__ + "static/media/uno.fe1283eb.png";